import { useContext } from 'rax';
import { default as Context } from './context';
import { getLocale } from './utils';
export function useLocale(componentName, props = {}, defaultLocale = {}) {
    const { locale } = useContext(Context);
    return getLocale(locale || {}, componentName, props, defaultLocale);
}
